import {capitalize} from 'lodash';

export default function humanizeString(string: string = '') {
  return string.replace(/((?!_)\w)+/g, capitalize).replace(/_/g, ' ');
}
